_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[20],{

/***/ "8I4s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__("vOnD");

// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__("IP2g");

// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__("CIUX");

// CONCATENATED MODULE: ./components/Bag.js





var Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Bag__Wrapper",
  componentId: "w7dtyd-0"
})(["display:flex;flex-direction:column;width:100%;> div{&:first-of-type{border-top:1px solid #d1cfcf;padding:var(--spacing-medium) var(--spacing-large);h3{font-size:2.5rem;margin:0 0 var(--spacing-tiny);}p{font-size:1.4rem;margin:0;}}&:nth-of-type(2){background-color:#f2f2f2;padding:var(--spacing-large);> div{background-color:var(--color-white);padding:var(--spacing-medium);border-radius:var(--border-radius);+ div{margin-top:var(--spacing-medium);}}}}"]);
var Heading = styled_components_browser_esm["default"].h1.withConfig({
  displayName: "Bag__Heading",
  componentId: "w7dtyd-1"
})(["font-family:var(--font-family-secondary);font-size:3rem;font-weight:var(--font-weight-secondary-medium);margin:0 0 var(--spacing-small);"]);
var Empty = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Bag__Empty",
  componentId: "w7dtyd-2"
})(["display:flex;flex-direction:column;align-items:center;svg{margin-bottom:var(--spacing-medium);}span{display:flex;justify-content:center;&:first-of-type{margin-bottom:var(--spacing-small);font-size:2rem;font-weight:700;}&:last-of-type{font-size:1.6rem;font-weight:300;}}"]);
var Total = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Bag__Total",
  componentId: "w7dtyd-3"
})(["display:flex;flex-direction:column;> div{display:flex;justify-content:space-between;align-items:center;&:first-of-type{margin-bottom:var(--spacing-medium);span{&:first-of-type{font-size:2.5rem;font-weight:700;}&:nth-of-type(2){font-size:1.4rem;font-weight:700;}}}&:nth-of-type(2){font-size:1.6rem;font-weight:300;margin-bottom:var(--spacing-medium);}&:nth-of-type(3){font-size:1.6rem;font-weight:300;margin-bottom:var(--spacing-medium);}&:nth-of-type(4){font-size:1.6rem;font-weight:700;margin-bottom:var(--spacing-large);}}hr{background-color:#bebebe;height:1px;width:100%;border:0;margin:0 0 var(--spacing-medium);}"]);

var Bag_ShoppingBag = function ShoppingBag() {
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])(Wrapper, {
    className: "full",
    children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
      children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(Heading, {
        children: "Bag"
      }), /*#__PURE__*/Object(jsx_runtime["jsx"])("p", {
        children: "Items are reserved for 60 minutes"
      })]
    }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
      children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])(Empty, {
        children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
          icon: ["fal", "dizzy"],
          color: "var(--color-black)",
          size: "10x"
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
          children: "It seems empty here"
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
          children: "Nothing to show right now"
        })]
      }), /*#__PURE__*/Object(jsx_runtime["jsxs"])(Total, {
        children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
            children: "Total"
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
            children: "0 items"
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
            children: "Subtotal"
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
            children: "\xA30.00"
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
            children: "Delivery fee"
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
            children: "\xA30.00"
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])("hr", {}), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
            children: "Total"
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])("span", {
            children: "\xA30.00"
          })]
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])(Button["a" /* default */], {
          disabled: true,
          text: "Checkout"
        })]
      })]
    })]
  });
};

/* harmony default export */ var Bag = (Bag_ShoppingBag);
// CONCATENATED MODULE: ./pages/bag.js



var bag_Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "bag__Wrapper",
  componentId: "sc-15puuco-0"
})(["display:grid;grid-template-columns:var(--spacing-large) 1fr var(--spacing-large);justify-items:center;> *{grid-column:2 / -2;}> .full{grid-column:1 / -1;}"]);

var bag_BagPage = function BagPage() {
  return /*#__PURE__*/Object(jsx_runtime["jsx"])(bag_Wrapper, {
    children: /*#__PURE__*/Object(jsx_runtime["jsx"])(Bag, {})
  });
};

/* harmony default export */ var bag = __webpack_exports__["default"] = (bag_BagPage);

/***/ }),

/***/ "CIUX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Ff2n");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("vOnD");




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].button.withConfig({
  displayName: "Button__Wrapper",
  componentId: "sc-1i4gz5q-0"
})(["display:flex;justify-content:center;font-size:2rem;font-family:var(--font-family-primary);font-weight:var(--font-weight-primary-medium);border-radius:var(--border-radius);padding:var(--spacing-small) var(--spacing-medium);outline:0;cursor:pointer;", " ", " ", " ", ""], function (_ref) {
  var primary = _ref.primary;
  return primary ? "\n    background-color: var(--color-primary);\n    color: var(--color-white);\n    border: 1px solid var(--color-primary);\n  " : null;
}, function (_ref2) {
  var ghost = _ref2.ghost;
  return ghost ? "\n    background-color: #f0f0f0;\n    color: var(--color-black);\n    border: 1px solid #cccccc;\n  " : null;
}, function (_ref3) {
  var primary = _ref3.primary,
      ghost = _ref3.ghost;
  return primary && ghost ? "\n    color: var(--color-primary);\n    border: 1px solid var(--color-primary);\n  " : null;
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? "\n      background-color: #bebebe;\n      border: 1px solid #bebebe;\n      color: #5f5f5f;\n  " : null;
});

var Button = function Button(_ref5) {
  var text = _ref5.text,
      children = _ref5.children,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref5, ["text", "children"]);

  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsxs"])(Wrapper, _objectSpread(_objectSpread({}, props), {}, {
    children: [children, text]
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),

/***/ "Ff2n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutProperties; });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("zLVn");

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ "uDyv":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bag",
      function () {
        return __webpack_require__("8I4s");
      }
    ]);
  

/***/ }),

/***/ "yLpj":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ })

},[["uDyv",0,1,2,5]]]);